<template>
<div id="dataset-elem">
  <div class="content-header text-center">
    <!-- div class="float-end text-right">
      <button type="button" @click="sortData"><i class="fa" :class="sorticon"></i></button>
    </div -->
    <h2>Idea Lab</h2>
  </div>
  <div class="container-fluid min-content-height">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <!-- div class="btn-group-vertical col-12"  v-for='data in datasets' v-bind:key="data">
          <div class="btn-group mb-2" role="group">
            <a class="btn col-10 btn-lg btn-primary" v-bind:href="'/generate_download_prospect?prospect='+data+'.csv'"  v-bind:download="data + '.csv'" target="_blank"><span class="sidebar-text">{{data.replace('.prospect','')}}</span></a>
            <a class="btn col-2 btn-lg btn-danger" @click="returnUpdatedList(String(data))"><i class="fas fa-trash-alt"></i></a>
            <a class="btn col-2 btn-lg btn-info d-none" @click="$emit('openModal', {view: 'RenameProspect', dt: String(data)})"><i class="fas fa-edit"></i></a>
            <a class="btn col-2 btn-lg btn-light" @click="$emit('openModal', {view: 'ProspectCriteria', dt: String(data)})"><i class="fas fa-info"></i></a>
          </div>
        </div -->
      </div>
    </div>
  </div>
</div>
</template>
<script>
export default {
  name: 'Idea Lab',
  components: {  },
  props: {

  },
  data() {
    
  },
  
}
</script>